import React from 'react';

import { useRedirectOnLoad } from '../../controllers/use-redirect-on-load';

import type { RedirectOnLoadProps } from './types';

export const RedirectOnLoad = <T,>({
	children,
	condition,
	href,
	redirect,
}: RedirectOnLoadProps<T>) => {
	// We can save some overhead if we evaluate the condition here rather than in the hook.
	// Avoiding the hook could be helpful when wrapping this component around a number of menu items but only needing redirect on one.
	if (!condition) {
		return <>{children}</>;
	}

	return (
		<RedirectOnLoadWithoutCondition href={href} redirect={redirect}>
			{children}
		</RedirectOnLoadWithoutCondition>
	);
};

const RedirectOnLoadWithoutCondition = <T,>({
	children,
	href,
	redirect,
}: Omit<RedirectOnLoadProps<T>, 'condition'>) => {
	useRedirectOnLoad(href, redirect);

	return <>{children}</>;
};
